import sortBy from 'lodash.sortby'
import keys from 'lodash.keys'
import uniq from 'lodash.uniq'

import dayjs from 'dayjs'

import { DEFAULT_BUFFER_DAYS } from './constants'

const INCREASE_OPS = ['available']
const DECREASE_OPS = ['in-dryclean', 'unavailable', 'in-rent', 'in-rent-transition']

export function filterAvailable(item) {
  return INCREASE_OPS.indexOf(item.status) > -1
}

export function filterUnavailable(item) {
  return DECREASE_OPS.indexOf(item.status) > -1
}

export function getCountChanges(sortedAvs) {
  let startDate = null
  let endDate = null

  let startCount = 0

  const countChangeByDate = {}

  for (const av of sortedAvs) {
    let koeff
    if (INCREASE_OPS.indexOf(av.status) > -1) {
      koeff = 1 * av.amount
    } else if (DECREASE_OPS.indexOf(av.status) > -1) {
      koeff = -1 * av.amount
    } else {
      continue
    }

    if (!av.dateFrom) {
      if (isNaN(startCount)) {
        startCount = koeff
      } else {
        startCount += koeff
      }
    } else {
      const dateFromStr = dayjs(av.dateFrom).format('YYYY-MM-DD')

      if (isNaN(countChangeByDate[dateFromStr])) {
        countChangeByDate[dateFromStr] = koeff
      } else {
        countChangeByDate[dateFromStr] += koeff
      }

      if (!startDate || dateFromStr < startDate) {
        startDate = dateFromStr
      }
      if (!endDate || dateFromStr > endDate) {
        endDate = dateFromStr
      }
    }
    if (av.dateTo) {
      const dateToStr = dayjs(av.dateTo).format('YYYY-MM-DD')
      const nextDay =  dayjs(av.dateTo).add(1, 'day').format('YYYY-MM-DD');
      if (isNaN(countChangeByDate[nextDay])) {
        countChangeByDate[nextDay] = -koeff
      } else {
        countChangeByDate[nextDay] -= koeff
      }

      if (!startDate || dateToStr < startDate) {
        startDate = dateToStr
      }
      if (!endDate || dateToStr > endDate) {
        endDate = dateToStr
      }
    }
  }

  return { startDate, endDate, startCount, countChangeByDate }
}

export function fillEveryDay({ startDate, endDate, startCount, countChangeByDate }) {
  let acc = startCount
  let date = dayjs(startDate)
  let dateStr = startDate
  const countByDate = {}

  while (dateStr <= endDate) {
    if (countChangeByDate[dateStr]) {
      acc += countChangeByDate[dateStr]
    }
    countByDate[dateStr] = acc
    date = date.add(1, 'day')
    dateStr = date.format('YYYY-MM-DD')
  }
  return countByDate
}

export function getStockByDates (avs) {
  // console.log('getStockByDates@avs', avs)

  const sortedAvs = sortBy(avs, ['dateFrom', 'dateTo'])
  // console.log('getStockByDates@sortedAvs', sortedAvs)
  const { startDate, endDate, startCount, countChangeByDate } = getCountChanges(sortedAvs)

  // console.log('getStockByDates @ count changes', { startDate, endDate, startCount, countChangeByDate })
  const countByDate = fillEveryDay({ startDate, endDate, startCount, countChangeByDate })

  // console.log('getStockByDates @ countByDate', countByDate)

  return countByDate
}

export function mergeStocksByDates(acc, stock) {
  const commonKeys = uniq(keys(acc).concat(keys(stock)))
  for (const key of commonKeys) {
    if(isNaN(acc[key])) {
      acc[key] = stock[key]
    } else if (isNaN(stock[key])) {
      // do nothing!
    } else {
      acc[key] = Math.min(acc[key], stock[key])
    }
  }
}

export function formatRentalDurationFromPricing(pricing) {
  return pricing.map(item => ({ value: Number(item.value), label: `${item.value} days`}))
}

export function getDurationOptions(sku) {
  if (sku.pricing && sku.pricing.map) {
    return formatRentalDurationFromPricing(sku.pricing)
  }
  return []
}

export function adjustStockForDuration(stock, duration, isSameDay, safeDays) {
  const bufferDays = safeDays ? safeDays : DEFAULT_BUFFER_DAYS
  const initialKeyList = keys(stock).sort()
  const now = dayjs().format('YYYY-MM-DD');
  const initialSafeDay = dayjs().add(bufferDays, 'day').format('YYYY-MM-DD');
  const nowIndex = initialKeyList.indexOf(now);
  const initialSafeDayIndex = initialKeyList.indexOf(initialSafeDay);

  if(!isSameDay) {
    const softDayKeys = initialKeyList.slice(nowIndex, initialSafeDayIndex)
    for(let i = 0; i < softDayKeys.length; i++) {
      const softDay = softDayKeys[i];
      stock[softDay] = 0;
    }
  }
  const keyList = initialKeyList.slice(nowIndex)

  // const minStraight = duration + 2 * SAFE_DAYS
  // const minStraight = isSameDay ? duration :  duration + 2 * SAFE_DAYS

  // we have rent-in-transition status
  const minStraight = duration

  let acc = 0

  for (let i = 0; i <  keyList.length; i++) {
    const dayKey = keyList[i]
    const amount = stock[dayKey]

    if (amount > 0) {
      acc++

      // const safeDays = isSameDay ? 0 : SAFE_DAYS
      // Reset start SAFE_DAYS
      // if (acc <= safeDays) {
      //   stock[dayKey] = 0
      //   console.log('Reset safe start', dayKey)
      // }
    } else {

      if (acc >= minStraight) {
        // console.log('Reset start and end', dayKey)

        // Reset END_SAFE_DAYS
        for (let j = i - 1; j > i - 1 - bufferDays; j--) {
          const key = keyList[j]
          stock[key] = 0
          // console.log('Reset safe end', key)
        }
        // console.log('end')

        acc = 0
      } else {
        // Reset all interval
        // console.log('Reset all interval')
        for (acc; acc > 0; acc--) {
          const key = keyList[i - acc]
          stock[key] = 0
        }
      }

    }
  }


}

// Sort test
// adjustStockForDuration({
//   '2020-01-01': 1,
//   '2020-03-03': 0,
//   '2020-02-02': 1,
// })
